import { API_BASE_URL, BRANCH_SUBSCRIPTIONS_SERVICES_API } from "utilities";
import axios from "axios";
import dayjs from "dayjs";

import { setChatbotAccess } from "./chatbot";

export function getBranchSubscriptionsServicesHasErrored() {
  return {
    type: "GET_BRANCH_SUBSCRIPTIONS_SERVICES_HAS_ERRORED",
    error: true,
    loading: false,
    data: [],
    isFetched: true,
  };
}

export function getBranchSubscriptionsServicesSuccess(data) {
  return {
    type: "GET_BRANCH_SUBSCRIPTIONS_SERVICES_SUCCESS",
    error: false,
    loading: false,
    data: data,
    isFetched: true,
  };
}

function fetchChatbotAccess(dispatch) {
  axios({
    method: "get",
    url: API_BASE_URL + "chatbot/access/",
    headers: { Authorization: localStorage.getItem("token") },
  })
    .then(({ data }) => {
      sessionStorage.setItem("chatbot_allowed", data.allowed ? "1" : "0");
      sessionStorage.setItem("chatbot_block_reason", data.reason || "");
      sessionStorage.setItem("chatbot_block_message", data.message || "");
      dispatch(setChatbotAccess({ allowed: data.allowed, reason: data.reason, message: data.message }));
    })
    .catch(() => {
      // Keep previous values or safe defaults on network failure
    });
}

export function getBranchSubscriptionsServices(data) {
  sessionStorage.setItem("subscription_valid_status", -1);
  return (dispatch) => {
    axios({
      method: "get",
      url: API_BASE_URL + BRANCH_SUBSCRIPTIONS_SERVICES_API,
      data: { cost: data },
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(function (response) {
        if (response.status === 200) {
          dispatch(getBranchSubscriptionsServicesSuccess(response.data.results));
          if (response.data.results.length > 0) {
            response.data.results.map(({ subscription_service, expires_on }) => {
              if (subscription_service.name === "RECEPTIONIST_APP") {
                const today = dayjs();
                const expiry_date = dayjs(expires_on);
                const validity_days = expiry_date.diff(today, "days") >= 0 ? expiry_date.diff(today, "days") + 1 : -1;
                sessionStorage.setItem("subscription_valid_status", validity_days);
              }
            });
          }
          fetchChatbotAccess(dispatch);
        } else {
          dispatch(getBranchSubscriptionsServicesHasErrored());
        }
      })
      .catch(function (error) {
        dispatch(getBranchSubscriptionsServicesHasErrored());
      });
  };
}
